module.exports = __webpack_public_path__ + "static/img/notification_banner.1117348c.png";